<mat-card class="prescription-review-view">
  <div class="row">
    <div class="col-md-6 d-flex">
      <div class="pe-5">
        <mat-card-title *ngIf="order"> Order #{{ order.id }} </mat-card-title>
        <mat-card-subtitle *ngIf="order">
          {{ order.status.status }}
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="order && sageUiEnabled">
          Sage: {{ getSageSyncLabel() }}
          <span *ngIf="order?.sage_invoice_id"> ({{ order?.sage_invoice_id }})</span>
        </mat-card-subtitle>
      </div>

      <div class="me-2" *ngIf="company && !individual">
        <mat-card-title> {{ company.name }} </mat-card-title>

        <mat-card-subtitle>
          {{
            company.phone_number +
              (company.phone_number_alt
                ? " / " + company.phone_number_alt
                : "
                    ")
          }}
        </mat-card-subtitle>
      </div>

      <div class="me-2" *ngIf="individual && !company">
        <mat-card-title>
          {{ individual.first_name + " " + individual.last_name }}
        </mat-card-title>

        <mat-card-subtitle>
          {{
            individual.phone_number +
              (individual.phone_number_alt
                ? " / " + individual.phone_number_alt
                : "
                    ")
          }}
        </mat-card-subtitle>
      </div>
    </div>

    <div class="col-md-6">
      <div class="me-2 text-end">
        <mat-form-field id="order-status" appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select
            required
            [disabled]="!perm.isPrescriptionReviewStaff()"
            (selectionChange)="onOrderStatusChanged($event)"
            [formControl]="orderStatusControl"
          >
            <mat-option *ngFor="let status of orderStatuses" [value]="status">
              {{ status.status }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="my-1">
    <p>
      <button mat-stroked-button class="me-2 mb-2" (click)="backToList()">
        <mat-icon>arrow_back</mat-icon> Back to list
      </button>
      <button
        [disabled]="!hasOrderItems"
        class="me-2 mb-2"
        (click)="openOrderSummary()"
        mat-stroked-button
      >
        <mat-icon>open_in_new</mat-icon> Order summary
      </button>
      <button
        (click)="openPrescriptionFile(order)"
        mat-stroked-button
        class="me-2 mb-2"
      >
        <mat-icon>open_in_new</mat-icon> Prescription file
      </button>
      <ng-container *ngIf="sageUiEnabled">
        <button
          *authGroup="['SuperAdmin']"
          (click)="syncOrderToSage()"
          mat-stroked-button
          class="me-2 mb-2"
        >
          <mat-icon>sync_alt</mat-icon> Sync to Sage
        </button>
      </ng-container>
      <button
        *ngIf="perm.isPrescriptionReviewStaff()"
        class="me-2 mb-2"
        [disabled]="orderItems.length <= 1"
        mat-stroked-button
        [routerLink]="orderSplitLink"
      >
        <mat-icon>splitscreen</mat-icon> Split order
      </button>
      <ng-container *authGroup="['SuperAdmin', 'OperationsManager', 'Packaging', 'Fulfilment']">
        <button
          [disabled]="!isFulfillable"
          *ngIf="order"
          [routerLink]="['/portal/fulfill', order.id]"
          class="me-2 mb-2"
          mat-stroked-button
        >
          <mat-icon>done</mat-icon> Fulfill
        </button>
      </ng-container>

      <button
        *ngIf="canCaptureWaybill && order"
        (click)="waybillOrder(order)"
        class="me-2 mb-2"
        mat-stroked-button
      >
        Create waybill
      </button>

      <button
        *ngIf="trackable"
        (click)="openOrderTrackDialog(order)"
        class="me-2 mb-2"
        mat-stroked-button
      >
        Track
      </button>
      <button mat-stroked-button class="me-2 mb-2" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-stroked-button class="me-2 mb-2" (click)="printOrderToPDF()">
        <mat-icon>print</mat-icon> Print Order
      </button>
      <button
        *ngIf="showDeliveryNoteButton"
        mat-stroked-button
        class="me-2 mb-2"
        (click)="printDeliveryNoteToPDF()"
      >
        <mat-icon>print</mat-icon> Delivery note
      </button>
    </p>
    <div *ngIf="order !== null && !hasOrderItems" class="py-1 no-medicine">
      <mat-icon color="warn">info</mat-icon>
      <span>No medicine has been ordered for this prescription</span>
    </div>
  </div>

  <div class="mt-3">
    <mat-tab-group>
      <mat-tab label="Order items">
        <core-add-medicine
          *ngIf="perm.canMutate()"
          (onMedicineAdd)="addOrderItem($event)"
        ></core-add-medicine>
        <div class="order-items-container">
          <core-order-item-list
            *ngIf="order"
            [order]="order"
            [orderStatus]="selectedStatus"
            [readOnly]="perm.isViewer()"
            (onDelete)="removeOrderItem($event)"
            [orderItems]="orderItems"
            [orderItemStatuses]="orderItemStatuses"
            [batchStatuses]="batchStatuses"
          >
          </core-order-item-list>
        </div>
      </mat-tab>
      <mat-tab label="Details">
        <div *ngIf="order" class="details my-2">
          <table>
            <tr>
              <th>Created</th>
              <td>
                {{ utilsService.formatTime(order.created_at) }}
              </td>
            </tr>
            <tr>
              <th>Updated</th>
              <td>
                {{ utilsService.formatTime(order.updated_at) }}
              </td>
            </tr>

            <tr>
              <th>Waybill number</th>
              <td>
                {{ waybillNumber ? waybillNumber : "-" }}
              </td>
            </tr>
            <tr>
              <th>Customer order number</th>
              <td>{{ customerOrderNumber ? customerOrderNumber : "-" }}</td>
            </tr>
          </table>
        </div>
        <mat-accordion multi="true">
          <mat-expansion-panel *ngIf="company">
            <mat-expansion-panel-header>
              <mat-panel-title> Company details </mat-panel-title>
              <mat-panel-description> &nbsp; </mat-panel-description>
            </mat-expansion-panel-header>

            <!---------------------------------------Display company details-------------------------------------->

            <div class="details">
              <div class="my-2">
                <button
                  *ngIf="perm.canMutate()"
                  (click)="editingCompany = !editingCompany"
                  mat-flat-button
                  color="primary"
                  class="me-2"
                >
                  {{ getEditCompanyButtonText() }}
                </button>

                <table class="mt-4" *ngIf="!editingCompany && company">
                  <tr>
                    <th>Name</th>
                    <td>
                      {{ company.name ? company.name : "-" }}
                    </td>
                  </tr>

                  <tr>
                    <th>Alternative email address</th>
                    <td>
                      {{ company.email_alt ? company.email_alt : "-" }}
                    </td>
                  </tr>

                  <tr>
                    <th>Phone number</th>
                    <td>
                      {{ company.phone_number ? company.phone_number : "-" }}
                    </td>
                  </tr>

                  <tr>
                    <th>Email</th>
                    <td>
                      {{ company.email ? company.email : "-" }}
                    </td>
                  </tr>

                  <tr>
                    <th>Alternative phone number</th>
                    <td>
                      {{
                        company.phone_number_alt
                          ? company.phone_number_alt
                          : "-"
                      }}
                    </td>
                  </tr>

                  <tr>
                    <th>Practice number</th>
                    <td>
                      {{
                        company.practice_number ? company.practice_number : "-"
                      }}
                    </td>
                  </tr>

                  <tr>
                    <th>VAT registration number</th>
                    <td>
                      {{
                        company.vat_registration_number
                          ? company.vat_registration_number
                          : "-"
                      }}
                    </td>
                  </tr>
                </table>
              </div>

              <!------------------------------------------Edit company details form------------------------------------------->

              <form
                *ngIf="editingCompany && company"
                class="mt-4"
                [formGroup]="companyDetailsForm"
              >
                <h3 class="my-2" mat-card-subtitle>Edit company details</h3>

                <div class="row">
                  <div class="col-md-6">
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Company name</mat-label>
                        <input
                          required
                          readonly
                          (click)="openSearchCompanyDialog()"
                          data-testid="company-name"
                          [disabled]="isLoading"
                          type="text"
                          placeholder="Company name"
                          matInput
                          formControlName="companyName"
                        />

                        <button
                          type="button"
                          *ngIf="!selectedCompany"
                          (click)="openSearchCompanyDialog()"
                          mat-icon-button
                          matSuffix
                          [attr.aria-label]="'Search for a company'"
                        >
                          <mat-icon>search</mat-icon>
                        </button>

                        <button
                          type="button"
                          *ngIf="selectedCompany"
                          (click)="deselectCompany()"
                          mat-icon-button
                          matSuffix
                          [attr.aria-label]="'Remove customer'"
                        >
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Phone number</mat-label>
                        <input
                          required
                          data-testid="company-phone-number"
                          formControlName="phoneNumber"
                          matInput
                          placeholder="Phone number"
                        />
                        <mat-error
                          *ngIf="companyDetailsForm.get('phoneNumber')?.invalid"
                        >
                          Phone number is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Alternative phone number</mat-label>
                        <input
                          data-testid="company-phone-number-alt"
                          formControlName="phoneNumberAlt"
                          matInput
                          placeholder="Alternative phone number"
                        />
                        <mat-error
                          *ngIf="
                            companyDetailsForm.get('phoneNumberAlt')?.invalid
                          "
                        >
                          Alternative phone number is not valid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Email address</mat-label>
                        <input
                          required
                          data-testid="company-email"
                          formControlName="email"
                          matInput
                          placeholder="Email address"
                        />
                        <mat-error
                          *ngIf="companyDetailsForm.get('email')?.invalid"
                        >
                          Email address is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Alternative email address</mat-label>
                        <input
                          data-testid="company-email-alt"
                          formControlName="emailAlt"
                          matInput
                          placeholder="Alternative email address"
                        />
                        <mat-error
                          *ngIf="companyDetailsForm.get('emailAlt')?.invalid"
                        >
                          Alternative email address is not valid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Practice number</mat-label>
                        <input
                          data-testid="company-practice-number"
                          formControlName="practiceNumber"
                          matInput
                          placeholder="Practice number"
                        />
                        <mat-error
                          *ngIf="
                            companyDetailsForm.get('practiceNumber')?.invalid
                          "
                        >
                          Practice number is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>VAT registration number</mat-label>
                        <input
                          data-testid="company-vat-reg-number"
                          formControlName="vatRegistrationNumber"
                          matInput
                          placeholder="VAT registration number"
                        />
                        <mat-error
                          *ngIf="
                            companyDetailsForm.get('vatRegistrationNumber')
                              ?.invalid
                          "
                        >
                          VAT registration number is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Type</mat-label>
                        <mat-select
                          required
                          data-testid="company-type"
                          formControlName="typeOfBusiness"
                        >
                          <mat-option [value]="undefined"
                            >Not Applicable</mat-option
                          >
                          <mat-option
                            *ngFor="let type of companyTypes"
                            [value]="type.id"
                          >
                            {{ type.type }}
                          </mat-option>
                        </mat-select>
                        <mat-error
                          *ngIf="
                            companyDetailsForm.get('typeOfBusiness')?.invalid
                          "
                        >
                          Select company type
                        </mat-error>
                      </mat-form-field>
                    </p>
                  </div>
                </div>

                <div class="py-2">
                  <mat-divider></mat-divider>
                </div>
              </form>

              <!---------------------------------------------- Select and display ompany distributor--------------------------------------->

              <div *ngIf="showDistributor" class="my-2">
                <div class="py-2">
                  <mat-divider></mat-divider>
                </div>
                <h3 mat-card-subtitle>Distributor</h3>
                <p>
                  <button
                    *ngIf="!selectedDistributor"
                    mat-stroked-button
                    (click)="openSearchDistributorDialog()"
                  >
                    Select distributor
                  </button>
                </p>
                <div *ngIf="selectedDistributor" class="details mt-2">
                  <div>
                    <!-- Distributor remove: hidden for now; uncomment to restore deselectDistributor(). -->
                    <!--
                    <button
                      mat-stroked-button
                      (click)="deselectDistributor()"
                      class="me-2 my-2"
                    >
                      <mat-icon>cancel</mat-icon> Remove
                    </button>
                    -->
                    <table class="mt-4">
                      <tr>
                        <th>Name</th>
                        <td>
                          {{
                            selectedDistributor.name
                              ? selectedDistributor.name
                              : "-"
                          }}
                        </td>
                      </tr>

                      <tr>
                        <th>Alternative email address</th>
                        <td>
                          {{
                            selectedDistributor.email_alt
                              ? selectedDistributor.email_alt
                              : "-"
                          }}
                        </td>
                      </tr>

                      <tr>
                        <th>Phone number</th>
                        <td>
                          {{
                            selectedDistributor.phone_number
                              ? selectedDistributor.phone_number
                              : "-"
                          }}
                        </td>
                      </tr>

                      <tr>
                        <th>Email</th>
                        <td>
                          {{
                            selectedDistributor.email
                              ? selectedDistributor.email
                              : "-"
                          }}
                        </td>
                      </tr>

                      <tr>
                        <th>Alternative phone number</th>
                        <td>
                          {{
                            selectedDistributor.phone_number_alt
                              ? selectedDistributor.phone_number_alt
                              : "-"
                          }}
                        </td>
                      </tr>

                      <tr>
                        <th>Practice number</th>
                        <td>
                          {{
                            selectedDistributor.practice_number
                              ? selectedDistributor.practice_number
                              : "-"
                          }}
                        </td>
                      </tr>

                      <tr>
                        <th>VAT registration number</th>
                        <td>
                          {{
                            selectedDistributor.vat_registration_number
                              ? selectedDistributor.vat_registration_number
                              : "-"
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="individual">
            <mat-expansion-panel-header>
              <mat-panel-title> Individual details </mat-panel-title>
              <mat-panel-description> &nbsp; </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="details">
              <div class="my-2">
                <button
                  *ngIf="perm.canMutate()"
                  (click)="editingIndividual = !editingIndividual"
                  mat-flat-button
                  color="primary"
                  class="me-2"
                >
                  {{ getEditIndividualButtonText() }}
                </button>
              </div>

              <!---------------------------------------Display individual details---------------------------------->

              <div class="mt-4" *ngIf="individual && !editingIndividual">
                <table>
                  <tr>
                    <th>Name</th>
                    <td>
                      {{ individual.first_name + " " + individual.last_name }}
                    </td>
                  </tr>

                  <tr>
                    <th>Address 1</th>
                    <td>
                      {{ address ? address.address_1 : "-" }}
                    </td>
                  </tr>

                  <tr>
                    <th>Building number</th>
                    <td>{{ address ? address.building_apt_number : "-" }}</td>
                  </tr>

                  <tr>
                    <th>Province</th>
                    <td>
                      {{ address ? address.province : "-" }}
                    </td>
                  </tr>

                  <tr>
                    <th>City</th>
                    <td>{{ address ? address.city : "-" }}</td>
                  </tr>

                  <tr>
                    <th>Postcode</th>
                    <td>
                      {{ address ? address.postcode : "" }}
                    </td>
                  </tr>

                  <tr>
                    <th>Country</th>
                    <td>
                      {{ address ? address.country : "-" }}
                    </td>
                  </tr>

                  <tr>
                    <th>Phone number</th>
                    <td>
                      {{
                        individual.phone_number ? individual.phone_number : "-"
                      }}
                    </td>
                  </tr>

                  <tr>
                    <th>Alternative phone number</th>
                    <td>
                      {{
                        individual.phone_number_alt
                          ? individual.phone_number_alt
                          : "-"
                      }}
                    </td>
                  </tr>

                  <tr>
                    <th>Email address</th>
                    <td>
                      {{ individual.email ? individual.email : "-" }}
                    </td>
                  </tr>

                  <tr>
                    <th>Alternative email address</th>
                    <td>
                      {{ individual.email_alt ? individual.email_alt : "-" }}
                    </td>
                  </tr>
                </table>
              </div>

              <!-----------------------------------Edit individual details form ---------------------------------->

              <div *ngIf="editingIndividual">
                <form class="mt-4" [formGroup]="individualDetailsForm">
                  <h3 class="my-2" mat-card-subtitle>
                    Edit individual details
                  </h3>

                  <div class="row">
                    <div class="col-md-6">
                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Title</mat-label>
                          <mat-select required formControlName="title">
                            <mat-option value="Mr">Mr</mat-option>
                            <mat-option value="Mrs">Mrs</mat-option>
                            <mat-option value="Miss">Miss</mat-option>
                            <mat-option value="Prof">Prof</mat-option>
                            <mat-option value="Dr">Dr</mat-option>
                          </mat-select>
                          <mat-error
                            *ngIf="individualDetailsForm.get('title')?.invalid"
                          >
                            Title is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Initials</mat-label>
                          <input
                            required
                            formControlName="initials"
                            matInput
                            placeholder="Initials"
                          />
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('initials')?.invalid
                            "
                          >
                            Initials are invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>First Name</mat-label>
                          <input
                            required
                            formControlName="firstName"
                            matInput
                            placeholder="First name"
                          />
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('firstName')?.invalid
                            "
                          >
                            First name is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Surname</mat-label>
                          <input
                            required
                            formControlName="lastName"
                            matInput
                            placeholder="Surname"
                          />
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('lastName')?.invalid
                            "
                          >
                            Surname is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Gender</mat-label>
                          <mat-select required formControlName="gender">
                            <mat-option value="male">Male</mat-option>
                            <mat-option value="female">Female</mat-option>
                            <mat-option value="other">Other</mat-option>
                          </mat-select>
                          <mat-error
                            *ngIf="individualDetailsForm.get('gender')?.invalid"
                          >
                            Gender is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Is the individual an animal?</mat-label>
                          <mat-select
                            required
                            data-testid="individual-is-animal"
                            formControlName="isAnimal"
                          >
                            <mat-option [value]="false">No</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                          </mat-select>
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('isAnimal')?.invalid
                            "
                          >
                            Invalid selection
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Date of birth</mat-label>
                          <input
                            required
                            formControlName="dateOfBirth"
                            matInput
                            [matDatepicker]="picker1"
                          />
                          <mat-datepicker-toggle matSuffix [for]="picker1">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker1></mat-datepicker>
                          <mat-error
                            *ngIf="individualDetailsForm.get('date')?.invalid"
                          >
                            Date of birth is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Individual type</mat-label>
                          <mat-select
                            [disabled]="isLoading"
                            #chosenValue
                            formControlName="individualType"
                          >
                            <mat-option
                              *ngFor="let type of individualTypes"
                              [value]="type.id"
                            >
                              {{ type.type }}
                            </mat-option>
                          </mat-select>
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('individualType')
                                ?.invalid
                            "
                          >
                            Individual type is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Phone Number</mat-label>
                          <input
                            required
                            formControlName="phoneNumber"
                            matInput
                            placeholder="Phone Number"
                          />
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('phoneNumber')?.invalid
                            "
                          >
                            Phone number is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label> Alternative phone number</mat-label>
                          <input
                            required
                            formControlName="phoneNumberAlt"
                            matInput
                            placeholder="Phone number"
                          />
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('phoneNumberAlt')
                                ?.invalid
                            "
                          >
                            Phone number is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Email address</mat-label>
                          <input
                            required
                            data-testid="individual-email"
                            formControlName="email"
                            matInput
                            placeholder="Email address"
                          />
                          <mat-error
                            *ngIf="individualDetailsForm.get('email')?.invalid"
                          >
                            Email address is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Alternative email address</mat-label>
                          <input
                            data-testid="individual-alt-email"
                            formControlName="emailAlt"
                            matInput
                            placeholder="Email address"
                          />
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('emailAlt')?.invalid
                            "
                          >
                            Alternative email address is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>

                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Number Of Dependants</mat-label>
                          <input
                            type="number"
                            min="0"
                            formControlName="numberOfDependants"
                            matInput
                            placeholder="Number of dependants"
                          />
                          <mat-error
                            *ngIf="
                              individualDetailsForm.get('numberOfDependants')
                                ?.invalid
                            "
                          >
                            Number of dependants is invalid
                          </mat-error>
                        </mat-form-field>
                      </p>
                      `
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Viewer: hide section entirely when there is no prescriber (no empty add form). -->
          <mat-expansion-panel *ngIf="prescriber || perm.canMutate()">
            <mat-expansion-panel-header>
              <mat-panel-title> Prescriber details </mat-panel-title>
              <mat-panel-description> &nbsp; </mat-panel-description>
            </mat-expansion-panel-header>

            <!----------------------------------Display prescriber details--------------------------------->

            <div class="details">
              <div class="my-2">
                <button
                  *ngIf="perm.canMutate()"
                  (click)="editingPrescriber = !editingPrescriber"
                  mat-flat-button
                  color="primary"
                  class="me-2"
                >
                  {{ getEditPrescriberButtonText() }}
                </button>

                <div class="mt-4" *ngIf="prescriber && !editingPrescriber">
                  <table>
                    <tr>
                      <th>Name</th>
                      <td>
                        {{ prescriber.first_name + " " + prescriber.last_name }}
                      </td>
                    </tr>

                    <tr>
                      <th>Phone number</th>
                      <td>
                        {{
                          prescriber.phone_number
                            ? prescriber.phone_number
                            : "-"
                        }}
                      </td>
                    </tr>

                    <tr>
                      <th>Alternative phone number</th>
                      <td>
                        {{
                          prescriber.phone_number_alt
                            ? prescriber.phone_number_alt
                            : "-"
                        }}
                      </td>
                    </tr>

                    <tr>
                      <th>Email address</th>
                      <td>
                        {{ prescriber.email ? prescriber.email : "-" }}
                      </td>
                    </tr>

                    <tr>
                      <th>Alternative email address</th>
                      <td>
                        {{ prescriber.email_alt ? prescriber.email_alt : "-" }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <!----------------------------------Edit prescriber details----------------------------------------->

              <form
                *ngIf="perm.canMutate() && (editingPrescriber || !prescriber)"
                class="mt-4"
                [formGroup]="prescriberDetailsForm"
              >
                <h3 class="my-2" mat-card-subtitle>Edit prescriber details</h3>

                <div class="row">
                  <div class="col-md-6">
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>First name</mat-label>
                        <input
                          required
                          readonly
                          (click)="openSearchPrescriberDialog()"
                          data-testid="individual-first-name"
                          formControlName="firstName"
                          matInput
                          placeholder="Start typing a name..."
                        />

                        <mat-error
                          *ngIf="
                            prescriberDetailsForm.get('firstName')?.invalid
                          "
                        >
                          First name is invalid
                        </mat-error>

                        <button
                          type="button"
                          *ngIf="!selectedPrescriber"
                          (click)="openSearchPrescriberDialog()"
                          mat-icon-button
                          matSuffix
                          [attr.aria-label]="'Search for a prescriber'"
                        >
                          <mat-icon>search</mat-icon>
                        </button>

                        <button
                          type="button"
                          *ngIf="selectedPrescriber"
                          (click)="deselectPrescriber()"
                          mat-icon-button
                          matSuffix
                          [attr.aria-label]="'Remove prescriber'"
                        >
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Last name</mat-label>
                        <input
                          required
                          data-testid="individual-last-name"
                          formControlName="lastName"
                          matInput
                          placeholder="Surname"
                        />
                        <mat-error
                          *ngIf="prescriberDetailsForm.get('lastName')?.invalid"
                        >
                          Last name is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Title</mat-label>
                        <mat-select
                          required
                          data-testid="individual-title"
                          formControlName="title"
                        >
                          <mat-option value="Mr">Mr</mat-option>
                          <mat-option value="Mrs">Mrs</mat-option>
                          <mat-option value="Miss">Miss</mat-option>
                          <mat-option value="Prof">Prof</mat-option>
                          <mat-option value="Dr">Dr</mat-option>
                        </mat-select>
                        <mat-error
                          *ngIf="prescriberDetailsForm.get('title')?.invalid"
                        >
                          Title is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Initials</mat-label>
                        <input
                          required
                          data-testid="individual-initials"
                          formControlName="initials"
                          matInput
                          placeholder="Initials"
                        />
                        <mat-error
                          *ngIf="prescriberDetailsForm.get('initials')?.invalid"
                        >
                          Initials are invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Gender</mat-label>
                        <mat-select
                          required
                          data-testid="individual-gender"
                          formControlName="gender"
                        >
                          <mat-option value="male">Male</mat-option>
                          <mat-option value="female">Female</mat-option>
                          <mat-option value="other">Other</mat-option>
                        </mat-select>
                        <mat-error
                          *ngIf="prescriberDetailsForm.get('gender')?.invalid"
                        >
                          Gender is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Date of birth</mat-label>
                        <input
                          required
                          data-testid="individual-date-of-birth"
                          formControlName="dateOfBirth"
                          matInput
                          [matDatepicker]="picker3"
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="picker3"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker3></mat-datepicker>
                        <mat-error
                          *ngIf="prescriberDetailsForm.get('date')?.invalid"
                        >
                          Date of birth is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>
                  </div>

                  <div class="col-md-6">
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Email address</mat-label>
                        <input
                          required
                          data-testid="individual-email"
                          formControlName="email"
                          matInput
                          placeholder="Email address"
                        />
                        <mat-error
                          *ngIf="prescriberDetailsForm.get('email')?.invalid"
                        >
                          Email address is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Alternative email address</mat-label>
                        <input
                          data-testid="individual-alt-email"
                          formControlName="emailAlt"
                          matInput
                          placeholder="Email address"
                        />
                        <mat-error
                          *ngIf="prescriberDetailsForm.get('emailAlt')?.invalid"
                        >
                          Alternative email address is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Number of dependants</mat-label>
                        <input
                          data-testid="individual-number-of-dependants"
                          type="number"
                          min="0"
                          formControlName="numberOfDependants"
                          matInput
                          placeholder="Number of Dependants"
                        />
                        <mat-error
                          *ngIf="
                            prescriberDetailsForm.get('numberOfDependants')
                              ?.invalid
                          "
                        >
                          Number of dependants is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Individual type</mat-label>
                        <mat-select
                          required
                          data-testid="individual-type"
                          [disabled]="isLoading"
                          #chosenValue
                          formControlName="individualType"
                        >
                          <mat-option
                            *ngFor="let type of individualTypes"
                            [value]="type.id"
                          >
                            {{ type.type }}
                          </mat-option>
                        </mat-select>
                        <mat-error
                          *ngIf="
                            prescriberDetailsForm.get('individualType')?.invalid
                          "
                        >
                          Individual type is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field required appearance="outline">
                        <mat-label>Phone number</mat-label>
                        <input
                          required
                          data-testid="individual-phone-number"
                          formControlName="phoneNumber"
                          matInput
                          placeholder="Phone number"
                        />
                        <mat-error
                          *ngIf="
                            prescriberDetailsForm.get('phoneNumber')?.invalid
                          "
                        >
                          Phone number is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>

                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Alternative phone number</mat-label>
                        <input
                          data-testid="individual-alt-phone-number"
                          formControlName="phoneNumberAlt"
                          matInput
                          placeholder="Phone number"
                        />
                        <mat-error
                          *ngIf="
                            prescriberDetailsForm.get('phoneNumberAlt')?.invalid
                          "
                        >
                          Alternative phone number is invalid
                        </mat-error>
                      </mat-form-field>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Shipping details </mat-panel-title>
              <mat-panel-description> &nbsp; </mat-panel-description>
            </mat-expansion-panel-header>

            <!----------------------------------Display delivery address--------------------------------->

            <div class="details">
              <div class="my-2">
                <div class="py-2" *ngIf="labelLinks.length > 0">
                  <h3 class="my-2" mat-card-subtitle>Labels</h3>

                  <button
                    class="me-2"
                    mat-raised-button
                    color="primary"
                    *ngFor="let link of labelLinks"
                    (click)="viewLabel(link)"
                  >
                    <mat-icon>open_in_new</mat-icon> Download Label
                  </button>
                  <button
                    *ngIf="waybillNumber"
                    class="mx-1"
                    [disabled]="isLoading"
                    color="primary"
                    mat-raised-button
                    (click)="printDeliveryLabel()"
                  >
                    <mat-icon>print</mat-icon> Print Delivery Label
                  </button>
                </div>

                <div class="py-2">
                  <mat-divider></mat-divider>
                </div>
                <h3 class="my-2" mat-card-subtitle>Delivery address</h3>

                <button
                  *ngIf="perm.canMutate()"
                  (click)="editingAddress = !editingAddress"
                  mat-flat-button
                  color="primary"
                  class="me-2"
                >
                  {{ getEditAddressButtonText() }}
                </button>

                <table class="mt-4" *ngIf="!editingAddress && address">
                  <tr>
                    <th>Delivery type</th>
                    <td>{{ getDeliveryType(order) }}</td>
                  </tr>

                  <tr>
                    <th>Address</th>
                    <td>{{ address.address_1 }}</td>
                  </tr>

                  <tr>
                    <th>Alternative address</th>
                    <td>{{ address.address_2 }}</td>
                  </tr>

                  <tr>
                    <th>Building number</th>
                    <td>{{ address.building_apt_number }}</td>
                  </tr>

                  <tr>
                    <th>Province</th>
                    <td>{{ address.province }}</td>
                  </tr>

                  <tr>
                    <th>City</th>
                    <td>{{ address.city }}</td>
                  </tr>

                  <tr>
                    <th>Postcode</th>
                    <td>{{ address.postcode }}</td>
                  </tr>

                  <tr>
                    <th>Country</th>
                    <td>{{ address.country }}</td>
                  </tr>
                </table>
              </div>

              <!----------------------------------Edit prescriber details----------------------------------------->

              <form
                *ngIf="editingAddress"
                class="mt-4"
                [formGroup]="addressDetailsForm"
              >
                <h3 class="my-2" mat-card-subtitle>Edit delivery address</h3>

                <form [formGroup]="addressDetailsForm" class="row">
                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Search for a country</mat-label>
                      <input
                        required
                        [disabled]="isLoading"
                        type="text"
                        placeholder="Search for a country"
                        aria-label="Search for a country"
                        matInput
                        formControlName="country"
                        [matAutocomplete]="auto"
                      />
                      <mat-autocomplete
                        autoActiveFirstOption
                        #auto="matAutocomplete"
                      >
                        <mat-option
                          *ngFor="let country of filteredCountries | async"
                          [value]="country.name"
                        >
                          {{ country.name }}
                        </mat-option>
                      </mat-autocomplete>
                      <mat-icon matPrefix>search</mat-icon>
                      <mat-error
                        *ngIf="addressDetailsForm.get('country')?.invalid"
                      >
                        Country is invalid
                      </mat-error>
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Province</mat-label>
                      <mat-select
                        required
                        data-testid="individual-province"
                        formControlName="province"
                      >
                        <mat-option
                          *ngFor="let province of provinces"
                          value="{{ province.name }}"
                        >
                          {{ province.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="addressDetailsForm.get('province')?.invalid"
                      >
                        Province is invalid
                      </mat-error>
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>City</mat-label>
                      <input type="text" formControlName="city" matInput />
                      <mat-error
                        *ngIf="addressDetailsForm.get('city')?.invalid"
                      >
                        City is invalid
                      </mat-error>
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Address line 1</mat-label>
                      <input
                        required
                        data-testid="individual-address-line-1"
                        formControlName="addressLine1"
                        matInput
                        placeholder="Address Line 1"
                      />
                      <mat-error
                        *ngIf="addressDetailsForm.get('addressLine1')?.invalid"
                      >
                        Address Line 1 is invalid
                      </mat-error>
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Suburb</mat-label>
                      <input
                        data-testid="individual-address-line-2"
                        formControlName="addressLine2"
                        matInput
                        placeholder="Suburb"
                      />
                      <mat-error
                        *ngIf="addressDetailsForm.get('addressLine2')?.invalid"
                      >
                        Suburb is invalid
                      </mat-error>
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Building Number</mat-label>
                      <input
                        required
                        data-testid="individual-building-apt-number"
                        formControlName="buildingAptNumber"
                        type="number"
                        min="1"
                        matInput
                        placeholder="Building Number"
                      />
                      <mat-error
                        *ngIf="
                          addressDetailsForm.get('buildingAptNumber')?.invalid
                        "
                      >
                        Building Number is required
                      </mat-error>
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Postcode</mat-label>
                      <input
                        required
                        data-testid="individual-postcode"
                        formControlName="postcode"
                        matInput
                        placeholder="Postcode"
                      />
                      <mat-error
                        *ngIf="addressDetailsForm.get('postcode')?.invalid"
                      >
                        Postcode is invalid
                      </mat-error>
                    </mat-form-field>
                  </p>

                  <p class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Select method of delivery</mat-label>
                      <mat-select
                        required
                        data-testid="individual-delivery-type"
                        #chosenValue
                        formControlName="deliveryType"
                      >
                        <mat-option
                          *ngFor="let type of deliveryTypes"
                          [value]="type.id"
                        >
                          {{ type.type }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="addressDetailsForm.get('deliveryType')?.invalid"
                      >
                        Choose from provided options
                      </mat-error>
                    </mat-form-field>
                  </p>
                </form>
              </form>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-tab>
    </mat-tab-group>
  </div>
  <mat-card-actions align="end" *ngIf="perm.canMutate()">
    <button
      class="mx-1"
      [disabled]="isLoading"
      color="primary"
      mat-raised-button
      (click)="submitData()"
    >
      <mat-icon>save</mat-icon> Save
    </button>
  </mat-card-actions>
</mat-card>